module.exports = __webpack_public_path__ + "static/media/fuiou-pay.72a11091.png";